<template>
  <ModuleContainer>
    <slot />
  </ModuleContainer>
</template>

<script>
// import L from '@plugins/leaflet'
import ModuleMixin from "@/components/Map/ModuleMixin";
import { ButtonGroupControl } from "@/components/Map/leaflet/ButtonGroupControl";

export default {
  mixins: [ModuleMixin],

  methods: {
    onInit() {
      this.addControl(
        ButtonGroupControl.create([
          {
            title: "Current Location",
            icon: "gps_fixed",
            onClick: () => {
              window.navigator.geolocation.getCurrentPosition(location => {
                this.map.panTo([
                  location.coords.latitude,
                  location.coords.longitude
                ]);
              });
            }
          }
        ])
      );
    },

    onDestroy() {}
  }
};
</script>
